import { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Swal from "sweetalert2";
import { ReactSession } from "react-client-session";
import { gapi } from "gapi-script";
import axios from "axios";
import "./App.css";
import "./config";
import Preloader from "./themes/sampanganimation/Pages/Preloader";

function App() {
  const [ThemeComponents, setThemeComponents] = useState(null);
  ReactSession.setStoreType("localStorage");

  // Fungsi kontrol loader
  const hideLoader = () => {
    const loader = document.getElementById("preloader");
    if (loader) loader.style.display = "none";
  };

  useEffect(() => {
    const initGoogleAPI = () => {
      gapi.load("client:auth2", () => {
        gapi.client.init({
          clientId: "203471354608-gognnrj3fe89bi5hf5451rplevpuil2s.apps.googleusercontent.com",
          scope: "",
        });
      });
    };

    const fetchTheme = async () => {
      try {
        const { data } = await axios.get(`${global.config.host}/themes`);
        if (data.status !== "success") throw new Error("Backend error");

        global.config.theme = data.theme;
        global.config.title = data.title;
        global.config.backend = `${global.config.host}/${data.theme}`;
        global.config.apiBappedalitbang = `${global.config.apiBappedalitbang}/${data.theme}`;

        // Update favicon
        const icon = document.querySelector('link[rel="icon"]');
        if (icon) {
          icon.href = `${global.config.backend}/api/getimage/L2Fzc2V0cy9pbWcvbG9nby5wbmc=`;
        }

        // Dynamic import components
        const HeaderLazy = lazy(() => import(`./themes/${data.theme}/Header.js`));
        const ContentLazy = lazy(() => import(`./themes/${data.theme}/Content.js`));
        const FooterLazy = lazy(() => import(`./themes/${data.theme}/Footer.js`));

        setThemeComponents(
          <BrowserRouter basename={`/${global.config.subdomain}`}>
            <HeaderLazy />
            <ContentLazy />
            <FooterLazy theme={data.theme} />
          </BrowserRouter>
        );
      } catch (err) {
        console.error(err);
        Swal.fire({
          title: "Error Connect",
          text: "Error connect to services",
          icon: "warning",
        });
      }
    };

    initGoogleAPI();
    fetchTheme();
  }, []);

  // Hilangkan loader ketika ThemeComponents sudah siap
  useEffect(() => {
    if (ThemeComponents) hideLoader();
  }, [ThemeComponents]);

  return ThemeComponents ? (
    <Suspense fallback={<Preloader />}>{ThemeComponents}</Suspense>
  ) : <Preloader />;
}

export default App;
